<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-menu
          ref="showDateDialog"
          v-model="showDateDialog"
          :close-on-content-click="false"
          :return-value.sync="dateSelect"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="dateSelectDisplay"
              prepend-icon="mdi-calendar"
              outlined
              v-bind="attrs"
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dateSelect"
            no-title
            @change="
              $refs.showDateDialog.save(dateSelectDisplay);
              showDateDialog = false;
              getReportAgentCash();
            "
          />
        </v-menu>
      </v-col>
    </v-row>

    <div class="mt-5">
      <v-simple-table>
        <template #default>
          <thead>
            <tr class="bg-dark">
              <th
                class="bg-dark text-center text-light"
                width="30%"
              >
                วันที่
              </th>
              <th
                class="bg-dark text-center text-light"
                width="20%"
              >
                ยอดฝาก
              </th>
              <th
                class="bg-dark text-center text-light"
                width="20%"
              >
                ยอดถอน
              </th>
              <th
                class="bg-dark text-center text-light"
                width="30%"
              >
                เหลือ
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in dataResult"
              :key="item.id"
            >
              <td>
                {{ item.dateStart }}
              </td>
              <td
                align="center"
                class="text-success text-right"
              >
                {{ Number(item.amount_debit).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_credit).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                :class="
                  item.amount_total > 0
                    ? 'text-right text-success'
                    : 'text-right text-danger'
                "
              >
                {{ Number(item.amount_total).toLocaleString("en-US") }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <v-dialog
      v-if="preload"
      v-model="preload"
      persistent
      width="500"
      max-width="100vw"
    >
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment-timezone';

export default {
  name: 'ReportCashAgentDaily',
  data: () => ({
    preload: false,
    showDateDialog: false,
    dateSelect: moment().format('YYYY-MM-DD'),
    dataResult: [],
  }),
  computed: {
    dateSelectDisplay() {
      return this.dateSelect;
    },
  },

  beforeMount() {
    this.getReportAgentCash();
  },
  methods: {
    getReportAgentCash() {
      this.preload = true;

      axios
        .get('/api/report/agentCash/daily', {
          params: {
            dateReport: this.dateSelect,
          },
        })
        .then((response) => {
          this.dataResult = response.data;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.preload = false;
        });
    },
  },
};
</script>
